import React, { useState } from 'react';
import { App as AntApp, Button, Flex, Modal, Typography } from 'antd';
import { ExportOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { EXTENSION_STORE_URL } from '../env';
import { startReview } from '../extensionBridge';

const { Paragraph, Text } = Typography;

/** The way to get the extension: a link to the store, or a note that it is not listed yet. */
export const GetExtension: React.FC<{ storeUrl?: string }> = ({
  storeUrl = EXTENSION_STORE_URL,
}) =>
  storeUrl ? (
    <Button
      type="primary"
      href={storeUrl}
      target="_blank"
      rel="noopener noreferrer"
      icon={<ExportOutlined />}
    >
      Get the extension for Chrome
    </Button>
  ) : (
    <Text type="secondary">Coming soon to the Chrome Web Store.</Text>
  );

/** Reviews happen in the extension: this asks it to open the review window, or explains how to get it. */
export const ReviewInExtension: React.FC<{ storeUrl?: string }> = ({ storeUrl }) => {
  const { message } = AntApp.useApp();
  const [busy, setBusy] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const review = async () => {
    setBusy(true);
    try {
      const result = await startReview();
      if (result === 'opened') {
        message.success('The review window is open.');
      } else if (result === 'missing') {
        setHelpOpen(true);
      } else {
        message.error(
          "The review window didn't open. Click the LingoPing icon in your toolbar instead."
        );
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button icon={<PlayCircleOutlined />} loading={busy} onClick={() => void review()}>
        Review in the extension
      </Button>
      <Modal
        title="Reviews happen in the LingoPing extension"
        open={helpOpen}
        onCancel={() => setHelpOpen(false)}
        footer={null}
      >
        <Flex vertical gap={12}>
          <Paragraph style={{ margin: 0 }}>
            Reviews happen in the LingoPing extension for Chrome.
          </Paragraph>
          <Paragraph style={{ margin: 0 }}>
            Install it and sign in with the same Google account.
          </Paragraph>
          <div>
            <GetExtension storeUrl={storeUrl} />
          </div>
        </Flex>
      </Modal>
    </>
  );
};
